<div class="popup-container tlms-popup">
    <header>
        <div class="header" style="display:block">{{heading}}</div>
        <button class="close" style="top:-3px" (click)="close()">
            <mat-icon>close</mat-icon>
        </button>
    </header>
    <ng-container>
        <div style="padding: 16px 24px 16px 24px;">
            <div class="col-12" style="width: 100%;">
                <div class="row">
                    <div class="col-md-6">
                        <div>
                            <label class="catlabel">Invoice Number:<span style="color:#ff0000">*</span></label>
                            <input type="text" [(ngModel)]="invoiceNumber" [maxlength]="10"
                                (keypress)="keyPressNumericInvoice($event)" [disabled]="eventType=='EDIT'">
                        </div>
                        <div>
                            <label class="catlabel">Freight Type:
                            </label>
                            <select class="F1" id="category-drop-down" class="drpDown" [(ngModel)]="freightTypeId">
                                <option [value]="freightType.freightTypeId"
                                    *ngFor="let freightType of freightTypeDropDown">
                                    {{freightType.description}}</option>
                            </select>
                        </div>
                        <div>
                            <label class="catlabel">Pallets:<span style="color:#ff0000">*</span></label>
                            <input type="number" [(ngModel)]="pallets">
                        </div>
                        <div>
                            <label class="catlabel">Gross Weight:<span style="color:#ff0000">*</span></label>
                            <input type="text" [(ngModel)]="grossWeight" (keyup)="(validate($event,'net'))"
                                (keypress)="keyPressAlphaNumeric($event)">
                        </div>
                        <div>
                            <label class="catlabel">IT Bond:</label>
                            <input type="text" [(ngModel)]="ITBond">
                        </div>
                    </div>

                    <div class="col-md-6">
                        <div>
                            <label class="catlabel">Comments:</label>
                            <textarea style="height: 95px;" [(ngModel)]="comments" [maxlength]="100"></textarea>
                        </div>
                        <div class="adjust-height">
                            <label class="catlabel">Sets:<span style="color:#ff0000">*</span></label>
                            <input type="number" [(ngModel)]="sets">
                        </div>
                        <div class="adjust-height">
                            <label class="catlabel">Net Weight:</label>
                            <input type="text" [(ngModel)]="netWeight" (keyup)="(validate($event,'net'))"
                                (keypress)="keyPressAlphaNumeric($event)">
                        </div>
                        <div class="adjust-height">
                            <label class="catlabel">Part Value:<span style="color:hsl(0, 100%, 50%)">*</span></label>
                            <input type="text" [(ngModel)]="partValue" (keyup)="(validate($event,'kg'))"
                                (keypress)="keyPressAlphaNumeric($event)">
                        </div>
                        <div class="adjust-height">
                            <label class="catlabel">BA#:</label>
                            <input type="text" [(ngModel)]="ba214">
                        </div>
                    </div>
                </div>
                <label *ngIf="errormsg" class="errormsg"> {{errormsg}} </label>
            </div>
        </div>
        <div class="cfooter d-flex justify-content-between align-items-center popup-footer">
            <button (click)="onNoClick()" class="mCancel"> CANCEL
            </button>
            <button class="black-btn" style="display: inline" (click)="saveClick()">
                SAVE
            </button>
        </div>
    </ng-container>
</div>